import { formatPrice } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Price } from '../../fuse-price/src/index';
import { ProductImage } from '../../fuse-product-image/src/product-image';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
// import ProductImage from './simple-product-image';
import imageSources from './config';
import SkeletonCardComponent from './simple-skeleton-card';
import StyledProductcard from './styled-simple-product-card';

const propTypes = {
	title: PropTypes.string,
	brand: PropTypes.string,
	imgUrl: PropTypes.string,
	imgAltText: PropTypes.string,
	prodUrl: PropTypes.string,
	price: PropTypes.number,
	prevPrice: PropTypes.number,
	priceSaving: PropTypes.number,
	showCurrentPriceFrom: PropTypes.bool,
	showPreviousPriceFrom: PropTypes.bool,
	showSave: PropTypes.bool,
	isEuro: PropTypes.bool,
	isSkeleton: PropTypes.bool,
};

const defaultProps = {
	title: ``,
	brand: ``,
	imgUrl: undefined,
	imgAltText: undefined,
	prodUrl: `#`,
	showCurrentPriceFrom: false,
	showPreviousPriceFrom: false,
	showSave: true,
	isEuro: false,
	price: 0,
	prevPrice: 0,
	priceSaving: 0,
	isSkeleton: false,
};

const BrandContainer = styled(TypographyComponent)`
	margin: 0 0 var(--spacing-global-space2) 0;
	min-height: calc(var(--font-size-1) + 4px);
	display: block;
	max-width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;

const TitleContainer = styled(TypographyComponent)`
	display: block;
	margin: 0 0 var(--spacing-global-space3);
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;

const StyledProductImage = styled(ProductImage)`
  margin-bottom: var(--spacing-global-space4); 
`;

const isAltExists = (text) =>
	(typeof text === 'string' || text instanceof String) && text.length > 1;

function SimpleProductCard({
	title,
	brand,
	imgUrl,
	imgAltText,
	prodUrl,
	price,
	prevPrice,
	priceSaving,
	showSave,
	showCurrentPriceFrom,
	showPreviousPriceFrom,
	isEuro,
	isSkeleton,
	...props
}) {
	const isAltUnreal = !isAltExists(imgAltText);
	const imgAlt = isAltUnreal ? `Missing image for: ${title}` : imgAltText;

	return isSkeleton ? (
		<SkeletonCardComponent className="fuse-product-card" {...props} />
	) : (
		<StyledProductcard className="fuse-product-card" href={prodUrl} {...props}>
			
			<StyledProductImage
				alt={imgAlt}
				src={imgUrl}
				lazy
				isAltReal={isAltUnreal}
				sources={imageSources}
				border="var(--border-width-xs) solid var(--color-global-grey300)"
			/>

			<BrandContainer
				type="paragraph"
				size="m1"
				tag="span"
				className="fuse-product-card__brand"
				data-testid="product-card__brand"
			>
				{brand}
			</BrandContainer>
			<TitleContainer
				type="heading"
				size="m1"
				tag="h3"
				className="fuse-product-card__title"
				data-testid="product-card__title"
			>
				{title}
			</TitleContainer>
			<Price
				className="fuse-product-card__price"
				headingTag="h4"
				isEuro={isEuro}
				prevPrice={formatPrice(prevPrice)}
				price={formatPrice(price)}
				saving={priceSaving}
				showCurrentFrom={showCurrentPriceFrom}
				showPreviousFrom={showPreviousPriceFrom}
				showSave={showSave}
				size="s"
				data-testid="product-card__price"
			/>
		</StyledProductcard>
	);
}

SimpleProductCard.propTypes = propTypes;
SimpleProductCard.defaultProps = defaultProps;

export { SimpleProductCard };

export default SimpleProductCard;
